// @mui
import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';

export const CustomTable = styled(Stack)((props) => ({
  [props.theme.breakpoints.down('sm')]: {
    marginRight: '-24px!important',
    marginLeft: '-24px!important',
  },
  '& .simpleTable': {
    '& .MuiTableRow-root': {
      whiteSpace: 'nowrap',
      [props.theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexFlow: 'column',
        borderTop: '1px solid #CBDCDE',
        '&:first-of-type': {
          borderTop: '2px solid #CBDCDE',
        },
        '&:nth-of-type(even)': {
          backgroundColor: props.theme.palette.root.brandPrimary_008,
        },
        '& .MuiTableCell-root': {
          borderBottom: '1px solid #CBDCDE',
        },
      },
    },
    '& .shrinkCell': {
      [props.theme.breakpoints.down('sm')]: {
        paddingLeft: '24px!important',
        '&:has(.empty)': {
          display: 'none',
        },
      },
    },
    '& .MuiTableCell-root': {
      [props.theme.breakpoints.down('sm')]: {
        padding: '6px',
        paddingLeft: 0,
      },
    },
    '& .MuiTableHead-root': {
      [props.theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    '& .tabletext': {
      [props.theme.breakpoints.down('sm')]: {
        width: '50%',
      },
      '&.mobileHeader': {
        paddingLeft: '24px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        [props.theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
    },
  },

  '& .MuiTableCell-root': {
    whiteSpace: 'nowrap',
  },
  '& .MuiTableContainer-root': {
    boxShadow: 'none',
    borderRadius: 0,
  },
  '& .MuiTableHead-root': {
    backgroundColor: props.theme.palette.root.darkGrayed_024,
    color: props.theme.palette.root.basicDeeoGreen,
    fontWeight: 'normal',
    '& .MuiTableSortLabel-icon': {
      fontSize: '20px',
      color: props.theme.palette.root.basicDeeoGreen,
    },
  },
  '& .MuiPagination-ul li button': {
    '&[class*=muirtl]': {
      '& .MuiSvgIcon-root': {
        rotate: '180deg',
      }
    },
    [props.theme.breakpoints.down('sm')]: {
      padding: 0,
      fontSize: '12px!important',
      margin: 0,
      minWidth: '24px',
      height: '24px',
    },
  },
  '& .MuiPaginationItem-root.Mui-selected': {
    backgroundColor: props.theme.palette.root.basicDeeoGreen,
    color: '#fff!important',
  },
  '& .hoverButton': {
    transition: props.theme.transitions.create(['background-color', 'transform'], {
      duration: props.theme.transitions.duration.standard,
    }),
    '& .hiddenActions': {
      transition: props.theme.transitions.create(['opacity', 'transform'], {
        duration: props.theme.transitions.duration.shortest,
      }),
      opacity: 0,
      [props.theme.breakpoints.down('sm')]: {
        opacity: 1,
        '&.MuiButtonBase-root': {},
      },
    },
    '&:hover': {
      backgroundColor: props.theme.palette.root.brandPrimary_008,
      [props.theme.breakpoints.down('sm')]: {
        backgroundColor: 'inherit',
      },
      '& .hiddenActions': {
        opacity: 1,
      },
    },
  },
  '& .tabletext': {
    [props.theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
  },
  '& .hideOnMobile': {
    [props.theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));
